<template>
  <div>
    <div class="ui-pannel">
      <p class="title">{{ $t('user.info') }}</p>
      <div class="content">
        <div class="avatar">
          <el-image
            v-if="!!info.userPicUrl"
            class="img"
            :src="info.userPicUrl"
            fit="cover"
          ></el-image>
        </div>
        <div class="info-item">
          <p>
            {{ info.teacherName
            }}<span v-if="info.sex === 1"><div class="man"></div> </span>
            <span v-else-if="info.sex === 2">
              <div class="women"></div>
            </span>
            <span class="tag" v-if="info.stateName === '待审核'"
              >Pending approval</span
            >
            <!-- <span class="tag waiting">待审核</span> -->
          </p>
          <div class="info">
            <div class="cell">
              <!-- <p>{{$t("form.gender")}}：<span class="txt" v-if="info.sex === 1"><div class="man"></div></span><span class="txt" v-else-if="info.sex === 2"><div class="women"></div></span><span class="txt" v-else>{{$t("common.other")}}</span></p> -->
              <p>
                {{ $t('level') }}：
                <span class="txt" v-if="info.teacherLevel === 1">{{
                  $t('common.Standard')
                }}</span>
                <span class="txt" v-if="info.teacherLevel === 2">{{
                  $t('common.Higher')
                }}</span>
                <span class="txt" v-if="info.teacherLevel === 3">{{
                  $t('common.Super')
                }}</span>
              </p>
              <p v-if="info.commentStar > 0">
                Rating：<el-rate
                  class="rate"
                  style="display: inline-block"
                  v-model="info.commentStar"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value}"
                ></el-rate>
              </p>
            </div>
            <div class="cell">
              <p>
                <span class="txt"
                  >{{ info.province }}&nbsp;{{ info.city }}</span
                >
              </p>
              <p>
                {{ $t('form.birth') }}：<span class="txt">{{
                  info.birthday
                }}</span>
              </p>
            </div>
            <div class="btns">
              <a @click="goFill" class="ui-btn">{{ $t('user.complete') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-pannel" v-if="user.userType === 20">
      <!-- 课时统计 -->
      <p class="title">Lesson statistics</p>
      <div class="content summary">
        <div class="complete">
          <p class="name">
            <i class="el-icon-success"></i>
            <!-- 已完成 -->
            <span>Complete</span>
          </p>
          <p class="num">{{ courseInfo.completedCount }}</p>
        </div>
        <div class="line"></div>
        <div class="waiting">
          <p class="name">
            <!-- 待预约 -->
            <span>Booked</span>
          </p>
          <p class="num">{{ courseInfo.waitingStartCount }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAmount } from '@/service/api.js'
import { getBaseProfile, getOrderCourseStats } from '@/service/teacherApi.js'
import moment from 'moment'
export default {
  data() {
    return {
      info: '',
      birthday: '',
      courseInfo: {}
    }
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    }
  },
  created() {
    this.getBaseProfile()
    this.getOrderCourseStats()
  },
  methods: {
    async getBaseProfile() {
      let res = await getBaseProfile({ teacherId: this.user.uid })
      if (res.data.status === 1) {
        this.info = res.data.data
        this.info.birthday = this.info.birthday !== 0 ? moment(this.info.birthday, "YYYYMMDD").format("DD/MM/YYYY") : '';
      }
    },
    goFill() {
      this.$router.push({ path: '/teacherFill', query: { type: 1 } })
    },
    async getOrderCourseStats() {
      let res = await getOrderCourseStats({ teacherId: 9, state: 0 })
      if (res.data.status === 1) {
        this.courseInfo = res.data.data
      }
    }
  },
  // watch: {
  //   "info.birthday": function(val){
  //     if(Number(this.birthday)!==0){
  //       console.log(this.birthday);
  //     }
  //   }
  // }
}
</script>
<style lang="scss" scoped>
.star {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: normal;
  background: url(../assets/star-full.png);
  background-size: cover;
  position: relative;
  top: 5px;
  margin: 0 5px;
}
.half-star {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: normal;
  background: url(../assets/star-half.png);
  background-size: cover;
  position: relative;
  top: 5px;
  margin: 0 5px;
}
.empty-star {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: normal;
  background: url(../assets/star.png);
  background-size: cover;
  position: relative;
  top: 5px;
  margin: 0 5px;
}
.man {
  margin-left: 5px;
  width: 24px;
  height: 24px;
  background-image: url(../assets/man.png);
  background-repeat: no-repeat;
  background-position: 0px 5px;
  background-size: cover;
  display: inline-block;
}
.women {
  margin-left: 5px;
  width: 24px;
  height: 24px;
  background-image: url(../assets/women.png);
  background-repeat: no-repeat;
  background-position: 0px 5px;
  background-size: cover;
  display: inline-block;
}
.content {
  display: flex;
  padding: 50px;
}
.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  font-size: 0;
  .img {
    width: 100%;
    height: 100%;
  }
}
.info-item {
  flex: 1;
  padding: 18px 0 0 40px;
  font-size: 18px;
  .tag {
    display: inline-block;
    padding: 0 14px;
    border-radius: 24px;
    height: 24px;
    line-height: 24px;
    background: #a9c4b1;
    color: #fff;
    margin-left: 20px;
    font-size: 14px;
  }
  .waiting {
    background: #a0a0a0;
  }
}
.info {
  display: flex;
  p {
    margin-top: 20px;
  }
  .txt {
color: #555;
  }
  .cell {
    width: 210px;
    white-space: nowrap;
  }
  .btns {
    flex: 1;
    text-align: center;
  }
}
.list {
  display: flex;
  margin-left: -25px;
  li {
    margin: 0 25px;
    padding-bottom: 20px;
    text-align: center;
  }
  .photo {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    overflow: hidden;
    font-size: 0;
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: rgba($color: #2680eb, $alpha: 0.55);
      display: none;
    }
    &:hover .tip {
      display: block;
    }
  }
  .name {
    margin-top: 10px;
    line-height: 21px;
    font-size: 18px;
  }
  .num {
    line-height: 19px;
color: #555;
  }
  .more {
    .photo {
      background: url(../assets/more.png);
    }
    .name {
      margin-top: 20px;
    }
  }
}
.account {
  .detail {
    width: 485px;
  }
  .name {
    color: #333;
    line-height: 21px;
    font-size: 18px;
  }
  .price {
    margin-top: 20px;
    font-size: 42px;
    line-height: 55px;
  }
  .tip {
color: #555;
    margin-top: 20px;
  }
  .btns {
    padding-top: 47px;
  }
}
.complete,
.waiting {
  padding: 30px 50px 40px 0;
  text-align: center;
  flex: 1;
  .name {
    font-size: 16px;
    line-height: 24px;
  }
  .num {
    margin-top: 10px;
    font-size: 42px;
    line-height: 55px;
    font-weight: bold;
  }
}
.complete {
  color: #a9c4b1;
  .el-icon-success {
    font-size: 24px;
    vertical-align: top;
    margin-right: 10px;
  }
}
.waiting {
  color: #ffa40e;
  .name:before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(../assets/waiting.png);
    vertical-align: top;
    margin-right: 10px;
  }
}
.summary {
  .line {
    height: 50px;
    margin-top: 50px;
    border-left: 1px dashed #ddd;
    width: 1px;
  }
}
</style>
<i18n>
{
  "cn": {
    "level": "级别"
  },
  "TW": {
    "level": "级别"
  },
  "en": {
    "level": "Level"
  }
}
</i18n>